import { forwardRef } from "react";
import {HiOutlineMapPin} from "react-icons/hi2";
import {Avatar, Badge, Button} from "Components/ui";
import classNames from "classnames";

const AddressSection = forwardRef(({address, text, general, components, onClick}, ref) => {
  return address.formattedAddress ?
    (
      <div
        className="flex justify-start items-center w-full"
        style={{
          fontFamily: text.body.font,
          color: text.body.color
        }}
      >
        <div className="flex items-start">
          <div title={address.formattedAddressWithAddress2 || address.formattedAddress}>
            <Badge
              content={<HiOutlineMapPin size={20} color={text.body.color}/>}
              innerClass="bg-transparent"
              badgeStyle={{
                top: '5px',
                left: '-2px'
              }}
            >
              <Avatar
                className="bg-transparent w-full h-full overflow-auto"
                shape="square"
                size="sm"
                icon={
                  <div
                    className="text-base font-medium ml-7"
                    style={{
                      fontFamily: text.body.font,
                      color: text.body.color
                    }}
                  >
                    {address.formattedAddressWithAddress2 || address.formattedAddress}
                  </div>
                }
              />
            </Badge>
          </div>
        </div>
        {
          !address.formattedAddress &&
            <div
              className="shrink-0 text-base sm:text-sm font-medium text-end ml-1">
              {address.formattedAddress ? ' | ' : ''}
              <a
                className="text-sky-500 cursor-pointer"
                onClick={onClick}
                style={{
                  fontFamily: text.hyperlink.font,
                  color: text.hyperlink.color
                }}
              >
                Enter your address to check availability
              </a>
            </div>
        }
      </div>
    ) : (
      <div
        className={classNames(
          {'min-h-[260px]': !general.details},
          'w-full max-w-2xl'
        )}
      >
        <Button
          ref={ref}
          variant="solid"
          className="w-full bg-transparent border hover:opacity-95"
          style={{
            borderRadius: general.element.corners === 'rounded' ? 'rounded-lg' : 'unset',
            background: components.alerts.bg,
            borderColor: components.alerts.border,
            color: components.alerts.text,
            fontFamily: text.body.font
          }}
          onClick={onClick}
          icon={<HiOutlineMapPin className="w-6 h-6 mr-2"/>}
        >
          Buy Now
        </Button>
      </div>
    )
});

export default AddressSection;
